/* eslint-disable react-hooks/exhaustive-deps */
import { Breadcrumb, Col, Form, FormGroup, Row } from "react-bootstrap";
import { Brand } from "../../components/forms/dataForms";
import { futureYears, rates, semesters } from "../administration/import/data";
import TableGoals from "./TableGoals";
import { useEffect, useState } from "react";
import FilterSelects from "../../components/forms/FilterSelects";
import { Fetch, IFetchProps } from "../../services/Fetch";
import { endpoints } from "../../data/endpoints";
import { useSelector } from "react-redux";
import { AlertSuccess } from "../../components/SweetAlerts/Alerts";

const Goals = () => {
  const { token } = useSelector((state: any) => state.auth.user);
  const [partsValue, setPartsValue] = useState<any>({});
  const [data, setData] = useState<any>({ percentaje: "00.00" });
  const [filters, setFilters] = useState<any>({ percentaje: "00.00" });
  const [load, setLoad] = useState<boolean>(false);

  const handleChangeInput = (e: any) => {
    const value = e.target.value;
    const regex = /^(?:[0-9]|)$/;

    if (regex.test(value)) {
      const parts = String(data?.percentaje)?.split("");
      let percentaje = "";

      if (e.target.name === "p1") {
        percentaje = `${value !== "" ? value : "0"}${parts[1] ?? "0"}.${
          parts[3] ?? "0"
        }${parts[4] ?? "0"}`;
      }
      if (e.target.name === "p2") {
        percentaje = `${parts[0] ?? "0"}${value !== "" ? value : "0"}.${
          parts[3] ?? "0"
        }${parts[4] ?? "0"}`;
      }
      if (e.target.name === "p3") {
        percentaje = `${parts[0] ?? "0"}${parts[1] ?? "0"}.${
          value !== "" ? value : "0"
        }${parts[4] ?? "0"}`;
      }
      if (e.target.name === "p4") {
        percentaje = `${parts[0] ?? "0"}${parts[1] ?? "0"}.${parts[3] ?? "0"}${
          value !== "" ? value : "0"
        }`;
      }
      console.log(percentaje);
      setData({ ...data, percentaje });
      setPartsValue({ ...partsValue, [e.target.name]: value });
    }
  };

  const handleChangeSelect = (opt: any) => {
    setData({ ...data, [opt.Name]: opt.value });
  };

  const handleSubmit = async (filters: any) => {
    if (data.edit) {
      const propsFetch: IFetchProps = {
        Endpoint: `${endpoints.goals.main}/${data.id}`,
        method: "PATCH",
        token,
        data: {
          program: filters.programFilters,
          targetPercentage: Number(data.percentaje),
          year: data.year,
          semester: data.semester,
          codeRate: data.codeRate,
        },
      };
      const response: any = await Fetch(propsFetch);
      if (response.statusCode && response.statusCode === 200) {
        AlertSuccess("Meta modificada exitosamente");
        setLoad(true);
      }
    } else {
      const propsFetch: IFetchProps = {
        Endpoint: `${endpoints.goals.main}`,
        method: "POST",
        token,
        data: {
          program: filters.programFilters,
          targetPercentage: Number(data.percentaje),
          year: data.year,
          semester: data.semester,
          codeRate: data.codeRate,
        },
      };
      const response: any = await Fetch(propsFetch);
      if (response.statusCode && response.statusCode === 201) {
        AlertSuccess("Meta guardada exitosamente");
        setLoad(true);
      }
    }
  };

  const handleCancel = () => {
    setData({});
    setPartsValue({});
  };

  useEffect(() => {
    if (data.percentaje && data.edit) {
      const parts = String(data?.percentaje)?.split("");
      setPartsValue({
        p1: parts[0],
        p2: parts[1],
        p3: parts[3],
        p4: parts[4],
      });
    }
  }, [data.percentaje]);

  useEffect(() => {
    if (data.percentaje && data.edit) {
      setFilters({
        programFilters: data.programFilters,
      });
    }
  }, [data.programFilters]);

  return (
    <div>
      <div className="breadcrumb-header justify-content-between">
        <div className="left-content">
          <span className="main-content-title mg-b-0 mg-b-lg-1">
            Indicadores y metas
          </span>
        </div>
        <div className="justify-content-center mt-2">
          <Breadcrumb>
            <Breadcrumb.Item className=" tx-15" href="#">
              Estadisticas
            </Breadcrumb.Item>
            <Breadcrumb.Item>Calculo de tasas</Breadcrumb.Item>
            <Breadcrumb.Item active aria-current="page">
              Indicadores y metas
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
      <Row style={{ marginBottom: "30px" }}>
        <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
          <FilterSelects
            onSubmit={handleSubmit}
            omit={["municipalityFilters", "areaFilters", "coreFilters"]}
            titleCard="Crear proyeccion de metas"
            btnLabel={data.edit ? "Editar meta" : "Guardar meta"}
            onCancel={handleCancel}
            filters={filters}
          >
            <Col sm={12} md={12} lg={4} xl={4}>
              <FormGroup className="form-group">
                <Form.Label className="form-label text-dark">Tasa</Form.Label>
                <Brand
                  Options={rates}
                  Placeholder="Seleccionar año"
                  Name="codeRate"
                  Onchange={handleChangeSelect}
                  defaultValue={rates?.find(
                    (item: any) => item.value === data.codeRate
                  )}
                />
              </FormGroup>
            </Col>
            <Col sm={6} md={6} lg={2} xl={2}>
              <FormGroup className="form-group">
                <Form.Label className="form-label text-dark">Año</Form.Label>
                <Brand
                  Options={futureYears()}
                  Placeholder="Año"
                  Name="year"
                  Onchange={handleChangeSelect}
                  defaultValue={futureYears()?.find(
                    (item: any) => item.value === data.year
                  )}
                />
              </FormGroup>
            </Col>
            <Col sm={6} md={6} lg={2} xl={2}>
              <FormGroup className="form-group">
                <Form.Label className="form-label text-dark">
                  Semestre
                </Form.Label>
                <Brand
                  Options={semesters}
                  Placeholder="Semestre"
                  Name="semester"
                  Onchange={handleChangeSelect}
                  defaultValue={semesters?.find(
                    (item: any) => item.value === data.semester
                  )}
                />
              </FormGroup>
            </Col>
            <Col sm={12} md={12} lg={4} xl={4}>
              <FormGroup className="form-group">
                <Form.Label className="form-label text-dark">
                  Porcentaje (%)
                </Form.Label>
                <Row>
                  <Col xs={2} md={2} lg={2} xl={2}>
                    <Form.Control
                      placeholder="0"
                      type="number"
                      name="p1"
                      min={0}
                      max={9}
                      onChange={handleChangeInput}
                      value={partsValue.p1 ?? 0}
                    />
                  </Col>
                  <Col xs={2} md={2} lg={2} xl={2}>
                    <Form.Control
                      placeholder="0"
                      type="number"
                      name="p2"
                      min={0}
                      max={9}
                      onChange={handleChangeInput}
                      value={partsValue.p2 ?? 0}
                    />
                  </Col>
                  <Col xs={2} md={2} lg={2} xl={2}>
                    <Form.Control
                      placeholder="0"
                      type="number"
                      name="p3"
                      min={0}
                      max={9}
                      onChange={handleChangeInput}
                      value={partsValue.p3 ?? 0}
                    />
                  </Col>
                  <Col xs={2} md={2} lg={2} xl={2}>
                    <Form.Control
                      placeholder="0"
                      type="number"
                      name="p4"
                      min={0}
                      max={9}
                      onChange={handleChangeInput}
                      value={partsValue.p4 ?? 0}
                    />
                  </Col>
                  <Col xs={4} md={4} lg={4} xl={4}>
                    <Form.Control
                      placeholder="0"
                      type="text"
                      name="percentaje"
                      min={0}
                      max={9}
                      // onChange={handleChangeInput}
                      value={data.percentaje ?? 0}
                    />
                  </Col>
                </Row>
              </FormGroup>
            </Col>
          </FilterSelects>
        </Col>
        <TableGoals load={load} setLoad={setLoad} setDataEdit={setData} />
      </Row>
    </div>
  );
};

export default Goals;
